<template>
<div>
    <div ref="drawerOverlay" class="mcc-drawer mcc-drawer--end mcc-drawer--w-md" type="modal">
        <div class="mu-d-flex mu-flex-column mu-h-100 mu-w-100">

            <!-- HEADER -->
            <div class="mcc-drawer__header mu-d-flex mu-justify-content-between">
                <h2 class="mu-fs-4">{{ title }}</h2>
                <button
                    type="button"
                    class="mcc-button mcc-button--sm mcc-button--ghost mcc-button--icon-only"
                    @click="close()"
                >
                    <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                </button>
            </div>

            <!-- BODY -->
            <div class="mcc-drawer__body mu-flex-grow-1" style="overflow-x: hidden; overflow-y: auto; position: relative;">
                
                <!-- SLOT CONTENT -->
                <slot></slot>

                <!-- SPINNER OVERLAY -->
                <div v-if="loading" class="assign-spinner-overlay">
                    <div class="assign-spinner-bg"></div>
                    <div class="assign-spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" style="width:48px;height:48px">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" />
                        </svg>
                    </div>
                </div>

            </div>

            <!-- FOOTER -->
            <div class="mcc-drawer__footer">
                <div class="mcc-button-group mcc-button-group--block mcc-button-group--spaced">
                    <button
                        class="mcc-button mcc-button--outline"
                        :disabled="loading"
                        @click="close()"
                    >
                        Cancel
                    </button>

                    <button
                        class="mcc-button mcc-button--primary"
                        :disabled="loading || !canSubmit"
                        @click="submit()"
                    >
                        {{ loading ? 'Submit' : 'Submit' }}
                    </button>
                </div>
            </div>

        </div>
    </div>

    <!-- SCRIM -->
    <div class="mcc-drawer__scrim" @click="!loading && close()"></div>
</div>
</template>

<script>
import constants from "../../constants";
export default {
    name: "AssignComponent",
    props: {
        title: {
            type: String,
            default: "Assign"
        },
        loading: {
            type: Boolean,
            default: false
        },
        canSubmit: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        submit() {
            this.$emit('assign')
            // this.close();
        },
        close() {
            this.$refs.drawerOverlay.classList.remove("mcc-drawer--open")
            this.$refs.drawerOverlay.classList.add("mcc-drawer--closed")
        },
        open() {
            this.$refs.drawerOverlay.classList.remove("mcc-drawer--closed")
            this.$refs.drawerOverlay.classList.add("mcc-drawer--open")
        }
    }
}
</script>

<style scoped>
.mcc-drawer[type=modal] {
    z-index: 3008 !important;
}
.assign-spinner-overlay {
    position: absolute;
    inset: 0;
    z-index: 20;
}

.assign-spinner-bg {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
}

.assign-spinner-flex {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
